var render = function (_h,_vm) {var _c=_vm._c;return _c('GmapCluster',{ref:"cluster",attrs:{"gridSize":30,"zoomOnClick":true,"minimumClusterSize":3,"styles":[{
    textSize: 18,
    url: _vm.props.imagePath,
    height: 40,
    width: 40,
    fontStyle: 'Roboto,Arial,sans-serif'
  }]}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }